export default function getFullName(item, capitalize = true, shorten = false) {
  if (!item) return ''
  let { firstName, lastName } = item
  lastName = (shorten ? lastName?.[0] : lastName) ?? ''
  return `${firstName} ${capitalize ? lastName?.toUpperCase() : lastName}`
}
